// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__30pOx","large":"styles_large__2S0eS"};